/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod';
import { experienceSchema } from './experience-schema';

export const candidateOpportunityExperienceSchema: z.AnyZodObject = z.object({
  candidateOpportunityId: z.string().uuid(),
  createdAt: z.string().datetime().nullish(),
  experience: z.lazy(() => experienceSchema).nullish(),
  experienceId: z.string().uuid(),
  experienceVisible: z.boolean().nullish(),
  highlighted: z.boolean(),
  id: z.string().uuid(),
  submissionDescription: z.string().nullish(),
  updatedAt: z.string().datetime().nullish(),
});

export type CandidateOpportunityExperience = z.infer<typeof candidateOpportunityExperienceSchema>;
